module.exports = __webpack_public_path__ + "static/media/balance-scale.66202e70.svg";